import "./toggleSwitch.scss";
import React, { useContext } from "react";

import languageContext from "../../context/languageContext";

const ToggleSwitch = () => {
  const { wichOne, langAvailable, chooseLanguage } =
    useContext(languageContext);

  const classSectionEnglish =
    wichOne === langAvailable.ENGLISH
      ? "toggle-container__english toggle-container__english--selected"
      : "toggle-container__english";
  const classSectionSpanish =
    wichOne === langAvailable.ESPAÑOL
      ? "toggle-container__spanish toggle-container__spanish--selected"
      : "toggle-container__spanish";

  return (
    <form className="toggle-container">
      <section className={classSectionEnglish}>
        <label htmlFor={langAvailable.ENGLISH}>EN</label>
        <input
          type="radio"
          name="language"
          id={langAvailable.ENGLISH}
          value={langAvailable.ENGLISH}
          onChange={(e) => chooseLanguage(e)}
          checked={wichOne === langAvailable.ENGLISH}
        />
      </section>
      <section className={classSectionSpanish}>
        <label htmlFor={langAvailable.ESPAÑOL}>ES</label>
        <input
          type="radio"
          name="language"
          id={langAvailable.ESPAÑOL}
          value={langAvailable.ESPAÑOL}
          onChange={(e) => chooseLanguage(e)}
          checked={wichOne === langAvailable.ESPAÑOL}
        />
      </section>
    </form>
  );
};

export default ToggleSwitch;
